/**
 * Returns the first argument provided to it.
 */
function identity(val) {
  return val;
}
module.exports = identity;